import React from 'react';
import { Link } from 'react-router-dom';
import Hero from '../components/Hero';
import '../styles/Home.css';

const Home = () => {
  return (
    <>
      <Hero />
      <div className="container">
        <section className="intro-section">
          <h2>Witaj w projekcie OperatorKredytowy.pl</h2>
          <p>
            Poniżej znajdziesz przegląd wszystkich dokumentów i materiałów związanych z projektem
            strony internetowej dla firmy z branży finansowej. Projekt obejmuje strukturę strony,
            wycenę, oraz propozycje kampanii reklamowych w Google Ads i mediach społecznościowych.
          </p>
        </section>

        <section className="services-section">
          <h2>Nasze materiały</h2>
          <div className="services-grid">
            <div className="service-card">
              <h3>Struktura Strony Finansowej</h3>
              <p>
                Logiczna struktura strony - podstrony, ich organizacja i słowa kluczowe pod które należy
                optymalizować treść dla firmy z branży finansowej.
              </p>
              <Link to="/website-structure" className="btn">
                Zobacz więcej
              </Link>
            </div>

            <div className="service-card">
              <h3>Wycena Strony</h3>
              <p>
                Szczegółowa wycena realizacji strony internetowej dla firmy OperatorKredytowy,
                zawierająca wszystkie koszty i harmonogram wdrożenia.
              </p>
              <Link to="/website-pricing" className="btn">
                Zobacz więcej
              </Link>
            </div>

            <div className="service-card">
              <h3>Facebook i TikTok Ads</h3>
              <p>
                Oferta usług reklamowych dla firm finansowych w mediach społecznościowych,
                z wyszczególnieniem dostępnych pakietów i ich zawartości.
              </p>
              <Link to="/facebook-tiktok-ads" className="btn">
                Zobacz więcej
              </Link>
            </div>

            <div className="service-card">
              <h3>Google Ads</h3>
              <p>
                Oferta kampanii reklamowych Google Ads dla firm z sektora finansowego,
                z wyszczególnieniem dostępnych pakietów i funkcjonalności.
              </p>
              <Link to="/google-ads" className="btn">
                Zobacz więcej
              </Link>
            </div>
          </div>
        </section>

        <section className="benefits-section">
          <h2>Korzyści dla Twojej firmy finansowej</h2>
          <div className="benefits-grid">
            <div className="benefit-item">
              <div className="benefit-icon">💻</div>
              <h3>Profesjonalna strona</h3>
              <p>Nowoczesna strona internetowa zoptymalizowana pod kątem konwersji i wyszukiwarek</p>
            </div>
            
            <div className="benefit-item">
              <div className="benefit-icon">🔍</div>
              <h3>Skuteczne reklamy</h3>
              <p>Kampanie reklamowe docierające do osób zainteresowanych usługami finansowymi</p>
            </div>
            
            <div className="benefit-item">
              <div className="benefit-icon">📱</div>
              <h3>Social Media</h3>
              <p>Obecność w mediach społecznościowych zwiększająca rozpoznawalność marki</p>
            </div>
            
            <div className="benefit-item">
              <div className="benefit-icon">📊</div>
              <h3>Analityka</h3>
              <p>Szczegółowe raporty i statystyki pomagające optymalizować działania marketingowe</p>
            </div>
          </div>
        </section>
        
      </div>
    </>
  );
};

export default Home;